import clsx from 'clsx';
import HubertInput from 'components/HubertUI/HubertInput';
import HubertLabel from 'components/HubertUI/HubertLabel';
import MutedText from 'components/common/MutedText';
import { ECreateQuestionMode, useQuestionEditorContext } from '../context/create-question.context';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionTitle, selectQuestionLanguage, selectQuestionMode } from 'rtk/questionEditorSelector';
import { updateTitle } from 'rtk/Question.Editor.Slice';
import { useInTemplateEditAndUneditable } from 'hooks/useInTemplateEditAndUneditable';
import { useTranslation } from 'react-i18next';

interface TitleInputProps {
  placeholder?: string;
  description?: string;
}

const TitleInput = ({ placeholder, description }: TitleInputProps) => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const questionTitle = useAppSelector((state) => selectQuestionTitle(state, questionId));
  const questionLanguage = useAppSelector((state) => selectQuestionLanguage(state, questionId));
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));
  const inTemplateEditAndUneditable = useInTemplateEditAndUneditable(questionId, mode);

  const titleValue = questionTitle[questionLanguage] ?? '';
  const disabled = mode === ECreateQuestionMode.InTemplateEdit;

  return (
    <div className={clsx(inTemplateEditAndUneditable && 'hidden', 'flex flex-col justify-start gap-4', 'p-1')}>
      <div
        className={clsx(
          inTemplateEditAndUneditable && 'hidden',
          'flex flex-row justify-start gap-4',
          'hubert-vertical-center',
        )}
      >
        <HubertLabel htmlFor="create-question-title">{t('titleInput.label')}</HubertLabel>
        <HubertInput
          id="create-question-title"
          value={titleValue}
          placeholder={placeholder ?? t('titleInput.defaultPlaceholder')}
          disabled={disabled}
          onChange={(e) => {
            dispatch(updateTitle({ questionId, language: questionLanguage, value: e.target.value }));
          }}
        />
      </div>
      <div>
        <MutedText text={description ?? t('titleInput.defaultDescription')} />
      </div>
    </div>
  );
};

export default TitleInput;
